import { AgendaGrid } from 'modules/arena/dashboard/components/AgendaGrid';
import { SelectedOrderPanel } from 'modules/arena/dashboard/components/SelectedOrderPanel';
import { OperationalQueue } from 'modules/arena/dashboard/components/OperationalQueue';
import { StatTile } from 'shared/components/ui/StatTile';
import { SkeletonStatTile } from 'shared/components/ui/Skeleton';
import { Button } from 'shared/components/ui/Button';
import { useArenaDashboard } from 'modules/arena/dashboard/useArenaDashboard';
import { useArenaProfile } from 'shared/contexts/ArenaProfileContext';
import { useToast } from 'shared/components/ui/Toast';

export function ArenaDashboardPage() {
  const { kpis, isLoading } = useArenaDashboard();
  const toast = useToast();
  const { profile } = useArenaProfile();

  return (
    <div className="flex flex-1 flex-col gap-6 p-6 lg:flex-row">
      <div className="flex-1">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div>
            <h1 className="font-heading text-xl font-bold text-ink">
              Agenda · quinta, 12 de setembro
            </h1>
            <p className="text-sm text-ink-secondary">
              {profile.arenaName} · {profile.courts.length} {profile.courts.length === 1 ? 'quadra' : 'quadras'} · 2
              pedidos aguardando cotas
            </p>
          </div>
          <Button
            onClick={() =>
              toast({
                tone: 'info',
                title: 'Novo evento na agenda',
                description: 'Em breve: bloqueio de quadra, aula avulsa ou evento. Reservas são criadas na tela Reservas.',
              })
            }
          >
            + Novo evento
          </Button>
        </div>

        <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
          {isLoading
            ? kpis.map((kpi) => <SkeletonStatTile key={kpi.label} />)
            : kpis.map((kpi) => <StatTile key={kpi.label} label={kpi.label} value={kpi.value} />)}
        </div>

        <div className="mt-6">
          <AgendaGrid />
        </div>
      </div>

      <div className="flex w-full flex-col gap-4 lg:w-72">
        <SelectedOrderPanel />
        <OperationalQueue />
      </div>
    </div>
  );
}
